import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { AnimationWrapper } from './views/animate';
import { DeathScreen } from './views/DeathScreen';

const LayoutComponent = () => (
	<AnimationWrapper>
		<Background />
		<DeathScreen />
	</AnimationWrapper>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.DeathScreen)
	.setHudVisible(false)
	.setTransitionTime(600)
	.build();

export default Layout;
